var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link-external",attrs:{"href":_vm.marketplaceURL,"target":"about:blank"}},[_vm._v("\n  "+_vm._s(_vm.productAsin)+"\n  "),_c('v-icon',{attrs:{"pack":"hv"}},[_vm._v("link")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }